var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-log-table',{attrs:{"adapt-height":false,"height":360,"params":{
      model: {shipNoteId: _vm.id}
    },"url":"/supply/shipNoteLog/logPage","columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }